import { CalendarDots, CreditCard, Target, Lightning, Sparkle } from "@phosphor-icons/react";

interface Props {
  availabilitySummary: string;
  serviceSummary: string;
  matchingSummary: string;
}

export function FinishStep({ availabilitySummary, serviceSummary, matchingSummary }: Props) {
  const rows = [
    { icon: <CalendarDots className="size-5" weight="duotone" />, title: "Radno vrijeme", sub: availabilitySummary },
    { icon: <CreditCard className="size-5" weight="duotone" />, title: "Usluga", sub: serviceSummary },
    { icon: <Target className="size-5" weight="duotone" />, title: "Oblasti rada", sub: matchingSummary },
  ];
  return (
    <div className="space-y-6">
      <div className="grid gap-3 sm:grid-cols-3">
        {rows.map((r) => (
          <div key={r.title} className="flex items-start gap-3 rounded-xl border border-border bg-card p-4 shadow-sm">
            <span className="text-primary">{r.icon}</span>
            <div>
              <h4 className="text-sm font-semibold">{r.title}</h4>
              <p className="text-xs text-muted-foreground">{r.sub}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="space-y-3 rounded-xl border border-border bg-muted/20 p-4 text-sm text-muted-foreground">
        <p className="flex gap-3">
          <Sparkle className="size-5 shrink-0 text-primary" weight="duotone" />
          <span>
            <b className="text-foreground">Savjet:</b> profili s video predstavljanjem dobijaju primjetno više
            rezervacija. Dodaj ga u <b>Postavke → Mediji</b> kad budeš imao/la vremena.
          </span>
        </p>
        <p className="flex gap-3">
          <Lightning className="size-5 shrink-0 text-primary" weight="duotone" />
          <span>
            Želiš nuditi i hitne konsultacije van rasporeda? Uključuješ ih u <b>Postavke → Hitne konsultacije</b>.
          </span>
        </p>
      </div>
    </div>
  );
}
